module.exports = {"House2":{"daobanList":[{"title":"1:是否签注居住证","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"居住证-签注居住证","state":"必要"},{"name":"监护人、近亲代为办理的，应当提供委托人、代办人的合法有效身份证原件和复印件、根据申请事由分别提供合法稳定就业，合法稳定住所，连续就读证明等原件及复印件","state":"必要"},{"name":"居住证","state":"必要"},{"name":"申请人居民身份证或者有效身份证明原件及复印件","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdh-2.json
// module id = 1258
// module chunks = 0